import React from "react"
import { Link } from "gatsby"

const BandTypes = ({ routeParams }) => (
  <div className="band-types-container">
    <div className="title-header">
      <h3 className="font-syne font-bold">BAND TYPES</h3>
    </div>
    <div className="band-types-lists-container grid grid-cols-2">
      <div className="band-types-list-column">
        <ul className="font-montserrat-13">
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/ceremony/violin-cello-duo/`}>
                Violin + Cello Duo
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/ceremony/string-trio/`}>
                String Trio
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/ceremony/string-quartet/`}>
                String Quartet
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/ceremony/solo-harp/`}>
                Instrumental Harp
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/ceremony/wedding-singer-guitarist/`}>
                Acoustic Singer
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/ceremony/male-vocals-guitar-violin/`}>
                Acoustic Singer + Violin
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/ceremony/female-male-vocals-guitar/`}>
                Acoustic Vocal Duo
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/ceremony/harp-vocals/`}>
                Harp + Vocals
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/ceremony/vocals-string-trio/`}>
                String Trio + Vocals
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/ceremony/vocal-duo-guitar-violin-bass/`}>
                Acoustic Duo + Violin & Bass
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/ceremony/wedding-singer/`}>
                Wedding Singer
              </Link>
            </div>
          </li>
        </ul>
      </div>
      <div className="band-types-list-column">
        <ul className="font-montserrat-13">
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/reception/one-piece-dj-combo/`}>
                One-Piece DJ Combo
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/reception/two-piece-dj-combo/`}>
                Two-Piece DJ Combo
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/reception/two-piece-band/`}>
                Two-Piece Band
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/reception/three-piece-band/`}>
                Three-Piece Band
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/reception/four-piece-band/`}>
                Four-Piece Band
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/reception/five-piece-band/`}>
                Five-Piece Band
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/reception/six-piece-band/`}>
                Six-Piece Band
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/reception/seven-piece-band/`}>
                Seven-Piece Band
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/reception/eight-piece-band/`}>
                Eight-Piece Band
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/reception/wedding-dj/`}>
                Wedding DJ
              </Link>
            </div>
          </li>
          <li>
            <div className="link">
              <Link to={`/${routeParams?.location}/reception/wedding-entertainment/`}>
                Wedding Entertainment
              </Link>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
)

export default BandTypes
